import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';
import { PosBusinessTermsAndConditionsService } from '@app/pos-channels/pos-business-tc/pos-business-tc.service';

@Injectable({ providedIn: 'root' })
export class PosChannelGuard implements CanActivateChild {

	constructor(
		private readonly posBusinessTermsAndConditionsService: PosBusinessTermsAndConditionsService,
	) {
	}
	canActivateChild() {
		if (this.posBusinessTermsAndConditionsService.isGracePeriodExpired && !this.posBusinessTermsAndConditionsService.isModalShowedOnce) {
			this.posBusinessTermsAndConditionsService.launchTCModal(this.posBusinessTermsAndConditionsService.isGracePeriodExpired);
			this.posBusinessTermsAndConditionsService.isModalShowedOnce = true;
		}
		return true;
	}
}
